// SmoothCollapse.jsx 🧱 Anti-overlap + instant open fix
import React, { useRef, useEffect, useState } from "react";

const SmoothCollapse = ({ show, children, duration = 400 }) => {
  const wrapperRef = useRef(null);
  const innerRef = useRef(null);
  const [rendered, setRendered] = useState(show);

  useEffect(() => {
    const wrapper = wrapperRef.current;
    const inner = innerRef.current;

    if (show) {
      setRendered(true); // Always render immediately

      requestAnimationFrame(() => {
        if (wrapper && inner) {
          wrapper.style.maxHeight = inner.scrollHeight + "px";
          wrapper.style.opacity = "1";
        }
      });

      const timeout = setTimeout(() => {
        if (wrapper) wrapper.style.maxHeight = "none";
      }, duration);
      return () => clearTimeout(timeout);
    } else {
      if (wrapper && inner) {
        wrapper.style.maxHeight = inner.scrollHeight + "px";

        requestAnimationFrame(() => {
          if (wrapper) {
            wrapper.style.maxHeight = "0px";
            wrapper.style.opacity = "0";
          }
        });

        const timeout = setTimeout(() => {
          setRendered(false);
        }, duration);
        return () => clearTimeout(timeout);
      }
    }
  }, [show, duration]);

  if (!rendered) return null;

  return (
    <div
      ref={wrapperRef}
      className="smooth-collapse"
      style={{
        overflow: "hidden",
        maxHeight: show ? "none" : "0px",
        opacity: show ? 1 : 0,
        transition: `max-height ${duration}ms ease, opacity ${duration}ms ease`,
        willChange: "max-height, opacity",
      }}
    >
      <div ref={innerRef}>{children}</div>
    </div>
  );
};

export default SmoothCollapse;
